"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getIconNameForItem = exports.DestinationTypeIcon = void 0;
var DestinationTypeIcon;
(function (DestinationTypeIcon) {
    DestinationTypeIcon["HOTEL"] = "hotel";
    DestinationTypeIcon["FLIGHT"] = "flug";
    DestinationTypeIcon["THEME"] = "themes";
    DestinationTypeIcon["GEO"] = "planet";
    DestinationTypeIcon["AIRPORT"] = "airport";
    DestinationTypeIcon["ROUNDTRIP"] = "rundreisen";
    DestinationTypeIcon["CRUISE"] = "cruise";
})(DestinationTypeIcon || (exports.DestinationTypeIcon = DestinationTypeIcon = {}));
function getIconNameForItem(item) {
    switch (item.__typename) {
        case 'FdrHotel':
            return DestinationTypeIcon.HOTEL;
        case 'FdrAirport':
            return DestinationTypeIcon.FLIGHT;
        case 'FdrTheme':
            return DestinationTypeIcon.THEME;
        case 'FdrRoundTrip':
            return DestinationTypeIcon.ROUNDTRIP;
        case 'FdrCruise':
            return DestinationTypeIcon.CRUISE;
        default:
            return DestinationTypeIcon.GEO;
    }
}
exports.getIconNameForItem = getIconNameForItem;
//# sourceMappingURL=fdr-travel-destination.utils.js.map